import { createHighlighter } from "shiki";
import theme from "./code-theme.json";

const SUPPORTED_LANGS = [
  "json",
  "javascript",
  "typescript",
  "jsx",
  "tsx",
  "yaml",
  "markdown",
  "html",
  "css",
  "bash",
  "shellscript",
];

let highlighterPromise = null;

function getHighlighter() {
  if (!highlighterPromise) {
    highlighterPromise = createHighlighter({
      themes: [theme],
      langs: SUPPORTED_LANGS,
    });
  }
  return highlighterPromise;
}

const PRE_INLINE_STYLE = [
  "padding:18px 20px",
  "border:1px solid rgba(255,255,255,0.04)",
  "border-radius:10px",
  "margin:0",
  "overflow-x:auto",
  "-webkit-overflow-scrolling:touch",
  "font-size:13px",
  "line-height:1.7",
  "font-family:var(--mono)",
].join(";");

export async function highlight(code, lang) {
  if (!lang || !SUPPORTED_LANGS.includes(lang)) return null;
  const highlighter = await getHighlighter();
  try {
    return highlighter.codeToHtml(code, {
      lang,
      theme: "ai-advisors-dark",
      transformers: [
        {
          pre(node) {
            const existingClass = node.properties?.class || "";
            node.properties.class = `${existingClass} code-block`.trim();
            const existingStyle = node.properties?.style || "";
            node.properties.style = `${existingStyle};${PRE_INLINE_STYLE}`;
          },
          code(node) {
            node.properties.style = "font-family:inherit;white-space:pre;display:block";
          },
        },
      ],
    });
  } catch {
    return null;
  }
}
